<!-- This file is auto-generated don't edit it! -->
<h1 id="preview">Preview</h1>
<p><ui-selectable-list-docs-preview></ui-selectable-list-docs-preview></p>
<h1 id="description">Description</h1>
<p>To be used as a generic and reusable way of handling multi/single selections over multiple options</p>
<h1 id="usage">Usage</h1>
<pre><code class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">h3</span>&gt;</span>Single<span class="hljs-tag">&lt;/<span class="hljs-name">h3</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">ui-selectable-list</span>
    #<span class="hljs-attr">list</span>
    [<span class="hljs-attr">allowUnselected</span>]=<span class="hljs-string">"false"</span>
    [(<span class="hljs-attr">selected</span>)]=<span class="hljs-string">"selectedOption"</span>
    [<span class="hljs-attr">multiSelect</span>]=<span class="hljs-string">"false"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span>
        <span class="hljs-attr">class</span>=<span class="hljs-string">"option"</span>
        *<span class="hljs-attr">ngFor</span>=<span class="hljs-string">"let option of options"</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">ui-radio</span>
            *<span class="hljs-attr">ngIf</span>=<span class="hljs-string">"option.type === 'radio'"</span>
            [<span class="hljs-attr">label</span>]=<span class="hljs-string">"option.label"</span>
            [<span class="hljs-attr">value</span>]=<span class="hljs-string">"option"</span>&gt;</span>
        <span class="hljs-tag">&lt;/<span class="hljs-name">ui-radio</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">ui-checkbox</span>
            *<span class="hljs-attr">ngIf</span>=<span class="hljs-string">"option.type === 'checkbox'"</span>
            [<span class="hljs-attr">label</span>]=<span class="hljs-string">"option.label"</span>
            [<span class="hljs-attr">value</span>]=<span class="hljs-string">"option"</span>&gt;</span>
        <span class="hljs-tag">&lt;/<span class="hljs-name">ui-checkbox</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">ui-button</span>
            #<span class="hljs-attr">btn</span>=<span class="hljs-string">"ui-selectable"</span>
            [<span class="hljs-attr">type</span>]=<span class="hljs-string">"btn.selected ? 'primary' : 'default'"</span>
            [<span class="hljs-attr">ui-selectable</span>]=<span class="hljs-string">"option"</span>
            *<span class="hljs-attr">ngIf</span>=<span class="hljs-string">"option.type === 'directive'"</span>
            [<span class="hljs-attr">text</span>]=<span class="hljs-string">"btn.selected ? 'Deselect' : 'Select'"</span>&gt;</span>
        <span class="hljs-tag">&lt;/<span class="hljs-name">ui-button</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ui-selectable-list</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>
    Variable 'selectedOption.label' is: {{ '{' }}{{ '{' }} selectedOption?.label {{ '}' }}{{ '}' }}
<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">h3</span>&gt;</span>Multi<span class="hljs-tag">&lt;/<span class="hljs-name">h3</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">ui-selectable-list</span>
    #<span class="hljs-attr">list2</span>
    [<span class="hljs-attr">allowUnselected</span>]=<span class="hljs-string">"true"</span>
    [(<span class="hljs-attr">selected</span>)]=<span class="hljs-string">"selectedOptions"</span>
    [<span class="hljs-attr">multiSelect</span>]=<span class="hljs-string">"true"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span>
        <span class="hljs-attr">class</span>=<span class="hljs-string">"option"</span>
        *<span class="hljs-attr">ngFor</span>=<span class="hljs-string">"let option of multiOptions"</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">ui-radio</span>
            *<span class="hljs-attr">ngIf</span>=<span class="hljs-string">"option.type === 'radio'"</span>
            [<span class="hljs-attr">label</span>]=<span class="hljs-string">"option.label"</span>
            [<span class="hljs-attr">value</span>]=<span class="hljs-string">"option"</span>&gt;</span>
        <span class="hljs-tag">&lt;/<span class="hljs-name">ui-radio</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">ui-checkbox</span>
            *<span class="hljs-attr">ngIf</span>=<span class="hljs-string">"option.type === 'checkbox'"</span>
            [<span class="hljs-attr">label</span>]=<span class="hljs-string">"option.label"</span>
            [<span class="hljs-attr">value</span>]=<span class="hljs-string">"option"</span>&gt;</span>
        <span class="hljs-tag">&lt;/<span class="hljs-name">ui-checkbox</span>&gt;</span>
        <span class="hljs-tag">&lt;<span class="hljs-name">ui-button</span>
            #<span class="hljs-attr">btn</span>=<span class="hljs-string">"ui-selectable"</span>
            [<span class="hljs-attr">ui-selectable</span>]=<span class="hljs-string">"option"</span>
            [<span class="hljs-attr">type</span>]=<span class="hljs-string">"btn.selected ? 'primary' : 'default'"</span>
            *<span class="hljs-attr">ngIf</span>=<span class="hljs-string">"option.type === 'directive'"</span>
            [<span class="hljs-attr">text</span>]=<span class="hljs-string">"btn.selected ? 'Deselect' : 'Select'"</span>&gt;</span>
        <span class="hljs-tag">&lt;/<span class="hljs-name">ui-button</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">ui-selectable-list</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>
    Length of 'selectedOptions' is: {{ '{' }}{{ '{' }} selectedOptions?.length {{ '}' }}{{ '}' }}
<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span></code></pre>
<h1 id="inputs">Inputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
</table>
<h1 id="outputs">Outputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
</table>
